import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import baseEn from './translations/en'
import baseIt from './translations/it'


// get UI translations from local files ./translations/{{lng}}.js
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      it: baseIt,
      en: baseEn
    },
    lng: 'it',
    fallbackLng: ['it', 'en'],
    ns: ['translations'],
    defaultNS: 'translations',
    compatibilityJSON: 'v4'
  })

export default i18n
